export const COLUMNS = [
  {
    id: 'requested',
    label: 'Time requested',
    field_name: 'requested',
    source_field: 'requested',
    showColumn: true,
    type: 'datetime',
  },
  {
    id: 'organization',
    label: 'Organization',
    field_name: 'organization',
    source_field: 'organization',
    showColumn: true,
  },
  {
    id: 'users',
    label: 'Number of users',
    field_name: 'users',
    source_field: 'users',
    showColumn: true,
  },
  {
    id: 'activation',
    label: 'Activation on',
    field_name: 'activation',
    source_field: 'activation',
    showColumn: true,
    type: 'datetime',
  },
  {
    id: 'action',
    label: '',
    field_name: 'action',
    showColumn: true,
  },
];

export const MESSAGES = {
  success: {
    title: `You Scheduled Activations were canceled successfully!`,
    details: `If you want to re-schedule, please go to Manage Learners > Schedule Activation`,
  },
  error: {
    title: `Oops! We had a problem canceling you Scheduled Activation. The action you're trying to cancel might be too close to the activations date.`,
    details: ` Please try again or contact the support.`,
  },
};

export default {
  COLUMNS,
  MESSAGES,
};
